import { Deserializable } from "@app/interfaces/deserializable";

export class LogEvent {

    co: string;
    activityDescription: string;
    activityCode: number;
    activityTime: Date;
    accountNumber: string;
    userName: string;
    remoteHost: string;
    userAgent: string;
    //webauthenticationId: number;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }
}
